<template>
  <div
    :class="{
      flex: true,
      'flex-col': true,
      'h-dvh': true,
      'gap-1': true,
      'pb-1': true,
      'pt-1': !isMobile,
      'px-1': !isMobile,
    }"
    :style="{
      'background-color': COLOR_BG1,
      color: COLOR_TEXT1,
    }"
  >
    <div
      v-if="isMobile"
      class="flex flex-row justify-between"
      :style="{ 'background-color': COLOR_BG2 }"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        :style="{ stroke: COLOR_TEXT1 }"
        class="h-6 m-2 cursor-pointer inline-block"
        v-on:click="onShowPairs"
      >
        <path d="M3 6h18v2H3V6m0 5h18v2H3v-2m0 5h18v2H3v-2Z"></path>
      </svg>
      <div class="p-2 cursor-pointer">
        <a href="https://docs.paapi.io" target="_blank" class="underline"
          >Docs</a
        >
      </div>
    </div>
    <div class="flex flex-row gap-1 h-full flex-1">
      <div
        :class="{
          flex: true,
          'flex-col': true,
          'gap-1': true,
          'py-1': true,
          'px-2': true,
          'flex-1': isMobile && showPairs,
          rounded: !isMobile,
        }"
        :style="{ 'background-color': COLOR_BG2 }"
        v-if="!isMobile || showPairs"
      >
        <input
          type="text"
          placeholder="Filter"
          class="p-1 outline-none rounded"
          v-model="pairsFilter"
          :style="{ 'background-color': COLOR_BG3, color: COLOR_TEXT1 }"
        />
        <div class="overflow-y-scroll gap-1">
          <div
            v-for="pair in filteredPairs"
            :key="pair.slug"
            :class="{
              'cursor-pointer': true,
              'px-1': true,
              'py-1': true,
            }"
            :style="{
              'background-color':
                pair.slug === selected ? COLOR_BG3 : COLOR_BG2,
              color: COLOR_TEXT1,
            }"
            v-on:click="onSelected(pair.slug)"
          >
            {{ pair.slug }}
            <span v-if="!pair.is_active" class="text-red-400 text-xs">D</span>
          </div>
        </div>
      </div>
      <div
        :class="{
          flex: true,
          'flex-col': true,
          'flex-1': true,
          'h-full': true,
          'gap-1': true,
          'px-1': isMobile,
        }"
        v-if="!isMobile || !showPairs"
      >
        <div
          class="flex flex-row gap-2 p-1 rounded justify-between select-none"
          :style="{ 'background-color': COLOR_BG2 }"
        >
          <div class="flex flex-row">
            <div
              :class="{
                'cursor-pointer': !isCurrent,
                'px-2': true,
                'py-1': true,
                rounded: true,
              }"
              v-on:click="onCurrent(true)"
              :style="{
                'background-color': !isCurrent ? COLOR_BG2 : COLOR_BG3,
              }"
            >
              Current
            </div>
            <div
              :class="{
                'cursor-pointer': isCurrent,
                'px-2': true,
                'py-1': true,
                rounded: true,
              }"
              v-on:click="onCurrent(false)"
              :style="{ 'background-color': isCurrent ? COLOR_BG2 : COLOR_BG3 }"
            >
              Changelog
            </div>
          </div>
          <div class="py-1 px-2 cursor-pointer underline">
            <a
              :href="`https://paapi.io/v1/pairs/${selected}/areas`"
              target="_blank"
              >JSON</a
            >
          </div>
        </div>
        <Chart
          v-if="klines.length && areas.length"
          :candles="filteredKlines"
          :areas="filteredAreas"
          :symbol="selected"
          exchange="Binance USDⓈ Futures"
          class="h-full rounded"
        />
        <div
          v-else
          class="h-full rounded text-center flex flex-col justify-center"
          :style="{ 'background-color': COLOR_BG2 }"
        >
          <div role="status" v-if="isLoading">
            <svg
              aria-hidden="true"
              class="inline w-8 h-8 animate-spin text-gray-600 fill-blue-600"
              viewBox="0 0 100 101"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                fill="currentColor"
              />
              <path
                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                fill="currentFill"
              />
            </svg>
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        <div
          class="p-2 flex flex-row rounded justify-between"
          :style="{ 'background-color': COLOR_BG2 }"
          v-if="!isMobile"
        >
          <div>
            <a
              href="https://docs.paapi.io/terms.html"
              target="_blank"
              class="underline"
              :style="{ color: COLOR_TEXT1 }"
              >Terms of Use</a
            >
          </div>
          <div class="px-1 cursor-pointer">
            <a
              href="https://docs.paapi.io"
              target="_blank"
              class="underline"
              :style="{ color: COLOR_TEXT1 }"
              >Docs</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref, computed } from "vue";
import Chart from "@/components/Chart.vue";
import { COLOR_BG1, COLOR_BG2, COLOR_BG3, COLOR_TEXT1 } from "@/constants";
import { useRoute, useRouter } from "vue-router";

const pairs = ref([]);
const areas = ref([]);
const klines = ref([]);
const isLoading = ref(false);
const selected = ref("BTCUSDT");
const isCurrent = ref(true);
const pairsFilter = ref("");
const isMobile = ref(false);
const showPairs = ref(false);

const route = useRoute();
const router = useRouter();

const makePoints = (area, first, last, is_current) => {
  const _start =
    Math.ceil(
      Math.max(first, is_current ? area.t0 : area.added_at) / (3600 * 24)
    ) *
    3600 *
    24;
  const _stop = Math.floor((area.removed_at || last) / (3600 * 24)) * 3600 * 24;
  return [
    [_start, parseFloat(area.a0) * _start + parseFloat(area.b0)],
    [_stop, parseFloat(area.a0) * _stop + parseFloat(area.b0)],
    [_stop, parseFloat(area.a1) * _stop + parseFloat(area.b1)],
    [_start, parseFloat(area.a1) * _start + parseFloat(area.b1)],
  ];
};

const filteredPairs = computed(() => {
  return pairs.value.filter((pair) =>
    pair.slug.toLowerCase().includes(pairsFilter.value.toLowerCase())
  );
});

const filteredAreas = computed(() => {
  const res = isCurrent.value
    ? areas.value.filter((area) => area.removed_at === null)
    : areas.value;
  return res.map((area) => ({
    ...area,
    points: makePoints(
      area,
      klines.value[0][0],
      klines.value[klines.value.length - 1][0],
      isCurrent.value
    ),
  }));
});

const filteredKlines = computed(() => {
  const start =
    Math.min(
      ...filteredAreas.value.map((area) =>
        Math.min(...area.points.map((point) => point[0]))
      )
    ) -
    3600 * 24 * 7;
  return klines.value.filter((kline) => kline[0] >= start);
});

const loadPairs = async () => {
  const response = await fetch("/v1/pairs");
  const isJson = response.headers
    ?.get("content-type")
    ?.includes("application/json");
  const data = isJson ? await response.json() : {};
  return data["items"];
};

const loadAreas = async () => {
  const response = await fetch(`/v1/pairs/${selected.value}/areas`);
  const isJson = response.headers
    ?.get("content-type")
    ?.includes("application/json");
  const data = isJson ? await response.json() : {};
  return data["items"];
};

const loadKlines = async () => {
  const response = await fetch(`/v1/pairs/${selected.value}/klines`);
  const isJson = response.headers
    ?.get("content-type")
    ?.includes("application/json");
  const data = isJson ? await response.json() : {};
  return data["items"];
};

onMounted(async () => {
  (function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4)
      )
    )
      isMobile.value = true;
  })(navigator.userAgent || navigator.vendor || window.opera);

  selected.value = route.query.pair || "BTCUSDT";

  isLoading.value = true;
  const pairsList = await loadPairs();
  pairs.value = pairsList.sort((a, b) => {
    if (a.is_active && !b.is_active) {
      return -1;
    } else if (!a.is_active && b.is_active) {
      return 1;
    } else {
      return a.slug.localeCompare(b.slug);
    }
  });
  const [_klines, _areas] = await Promise.all([loadKlines(), loadAreas()]);
  klines.value = _klines.slice(-200);
  areas.value = _areas;
  isLoading.value = false;
});

const onSelected = async (pair) => {
  if (pair === selected.value) {
    return;
  }

  showPairs.value = false;
  pairsFilter.value = "";

  router.push({ path: "/", query: { pair: pair } });

  selected.value = pair;
  isLoading.value = true;
  klines.value = [];
  areas.value = [];
  const [_klines, _areas] = await Promise.all([loadKlines(), loadAreas()]);
  klines.value = _klines.slice(-200);
  areas.value = _areas;
  isLoading.value = false;
};

const onCurrent = async (val) => {
  isCurrent.value = val;
};

const onPairsFilter = (event) => {
  pairsFilter.value = event.target.value;
};

const onShowPairs = () => {
  showPairs.value = !showPairs.value;
};
</script>
